export default "__VITE_ASSET__DV9nY_mf__"